import { LitElement, css } from 'lit';
import { sharedFont } from './font.js';
import { sharedStyle } from './style.js';

export default class KaiElement extends LitElement {
  static get properties() {
    return {
      isRtl: { type: Boolean },
    };
  }

  static get styles() {
    return [
      sharedFont,
      sharedStyle,
      css`
        * {
          font-family: 'Open Sans';
        }

        :host {
          /* z-index */
          --z-index-dialog: 100;
          --z-index-sidemenu: 10;
          --z-index-optionmenu: 99;
          --z-index-optionmenu-icon: 100;
          --z-index-popupmenu: 100;
        }

        /* override the default background-color applied on role="button" */
        [role='button']:active {
          background-color: transparent;
        }
      `,
    ];
  }

  constructor() {
    super();
    this.isRtl = false;
  }

  firstUpdated() {
    this.dirChange();
  }

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('unload', this);
    window.addEventListener('languagechange', this);
  }

  disconnectedCallback() {
    this.removeAllListener();
    super.disconnectedCallback();
  }

  handleEvent(evt) {
    switch (evt.type) {
      case 'languagechange':
        this.dirChange();
        break;
      case 'unload':
        if (this.isConnected) {
          // eslint-disable-next-line no-console
          console.warn(
            `${this.localName} is still connected! manually cleanup`
          );
        }
        this.removeAllListener();
        break;
      default:
        break;
    }
  }

  removeAllListener() {
    window.removeEventListener('unload', this);
    window.removeEventListener('languagechange', this);
  }

  dirChange() {
    const lang = navigator.language;
    const rtlList = [
      'ar-SA',
      'he-IL',
      'fa-IR',
      'ps-AF',
      'qps-plocm',
      'ur-PK',
      'ks-IN',
      'ur-IN',
    ];
    this.isRtl = rtlList.includes(lang);
    document.documentElement.dir = this.isRtl ? 'rtl' : 'ltr';
  }
}
